import type { ShopBannerProps } from '../components/ShopBanner';
import { shopProducts, type ShopProductKey } from './products';
export type { ShopProductKey } from './products';

export type ShopCategoryId = 88 | 134 | 1683 | 1174 | 1971;

export const categoryToProduct: Record<ShopCategoryId, ShopProductKey> = {
  88: 'boiler',
  134: 'boiler',
  1683: 'solar',
  1174: 'solar',
  1971: 'air-conditioning',
};

export function getShopBannerConfig(
  categoryId: ShopCategoryId,
): ShopBannerProps {
  return {
    ...shopProducts[categoryToProduct[categoryId]],
    productName: categoryToProduct[categoryId],
  };
}
